import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'

import Rating from '@material-ui/lab/Rating'
class ProductsList extends React.Component {
  state = {
    Products_data: [],
  }
  handleStatusChange = (sid) => {
    var isChecked = $('#Products_status_' + sid)
    isChecked.prop('checked', !isChecked.prop('checked'))
    var status = false
    if (!isChecked.prop('checked') === true) {
      status = 'active'
    } else {
      status = 'inactive'
    }
    let newArray = this.state.Products_list
    var a = newArray.find((element) => {
      return element.ProductsID === sid
    })
    a.status = status
    this.setState({ Products_list: newArray })
    Swal.fire('Update Status!', 'Status has been updated.', 'success')
  }
  deleteProducts = () => {}

  render() {
    const columns = [
      {
        name: 'productName',
        label: 'Products',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'category',
        label: 'Category',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'productSku',
        label: 'Products SKU',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'price',
        label: 'Products Price',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'seller',
        label: 'Shop',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'ratings',
        label: 'Rating',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (ratings) => {
            return (
              <div>
                <Rating
                  name="read-only"
                  value={ratings}
                  readOnly
                />
              </div>
            )
          },
        },
      },
      {
        name: 'ID',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (hotID) => {
            return (
              <div>
                <Link
                  to={'/Products/add/' + hotID}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteProducts.bind(this, hotID)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Products List</h4>
                    </div>
                  </div>
                  <Link
                    to="/customproduct/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Products
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Products List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Products List'}
                          className="table-responsive"
                          data={this.state.Products_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductsList
